import { graphql } from "@/api/graphql/types/gql";

export const GetSupportsAndDivisionsQuery = graphql(`
  query GetSupportsAndDivisions {
    LedgersMsGetSupportsAndDivisions {
      supportAccounts {
        divisionAccounts {
          label
          originalLabel
          walletId
        }
        label
        originalLabel
        walletId
      }
    }
  }
`);
